import { withTranslation } from 'react-i18next';
import numeral from 'numeral';

import ReactSelect from '../../../../components/ReactSelect';
import { GRID_SELECT } from '../../GscTools/selectStyles';
import { IMPRESSION_OPTIONS, SHARE_OPTIONS, URL_OPTIONS } from '../rule';

/**
 * The candidate rule, at the top of block 01.
 *
 * Unlike the scope bar it has no Apply. Every value is picked from a fixed list, so there is no
 * half-typed state to protect, and the rule asks Search Console nothing: changing it re-reads the
 * evaluations already in memory and every block below follows at once. The note says so, so the
 * page never implies that Google filtered anything.
 */
function RuleControls({ t, rule, onChange }) {
    const field = (key, label, options, format) => {
        const items = options.map((value) => ({ value, label: format(value) }));

        return (
            <div className="gsc-tool-field">
                <label>{label}</label>
                <ReactSelect
                    options={items}
                    value={items.find((item) => item.value === rule[key])}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ [key]: item.value })}
                />
            </div>
        );
    };

    return (
        <>
            <div className="gsc-tool-criteria">
                {field(
                    'minImpressions',
                    t('tools.cannibalization.rule.min_impressions'),
                    IMPRESSION_OPTIONS,
                    (value) => numeral(value).format('0,0'),
                )}
                {field(
                    'minShare',
                    t('tools.cannibalization.rule.min_share'),
                    SHARE_OPTIONS,
                    (value) => numeral(value).format('0%'),
                )}
                {field('minUrls', t('tools.cannibalization.rule.min_urls'), URL_OPTIONS, String)}
            </div>
            <p className="gsc-tool-rules-note">{t('tools.cannibalization.rule.local_note')}</p>
        </>
    );
}

export default withTranslation()(RuleControls);
